import PositioningDeviceTypeAddProcessremarkModal from './positioning-device-type-add-processremark-modal.vue'
export default PositioningDeviceTypeAddProcessremarkModal
